import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Experiences = lazy(() => import("@/pages/agent/galaxy/experiences/Experiences/Experiences"));
const AddExperience = lazy(() => import("@/pages/agent/galaxy/experiences/AddExperience"));
const EditExperience = lazy(() => import("@/pages/agent/galaxy/experiences/EditExperience/EditExperience"));

const Prospects = lazy(() => import("@/pages/agent/galaxy/prospects/Prospects/Prospects"));
const AddProspect = lazy(() => import("@/pages/agent/galaxy/prospects/AddProspect"));
const EditProspect = lazy(() => import("@/pages/agent/galaxy/prospects/EditProspect/EditProspect"));

const Posts = lazy(() => import("@/pages/agent/galaxy/posts/Posts/Posts"));
const AddPost = lazy(() => import("@/pages/agent/galaxy/posts/AddPost"));
const EditPost = lazy(() => import("@/pages/agent/galaxy/posts/EditPost/EditPost"));

const Blogs = lazy(() => import("@/pages/agent/galaxy/blogs/Blogs/Blogs"));
const AddBlog = lazy(() => import("@/pages/agent/galaxy/blogs/AddBlog"));
const EditBlog = lazy(() => import("@/pages/agent/galaxy/blogs/EditBlog/EditBlog"));

const Offers = lazy(() => import("@/pages/agent/galaxy/offers/Offers/Offers"));
const AddOffer = lazy(() => import("@/pages/agent/galaxy/offers/AddOffer"));
const EditOffer = lazy(() => import("@/pages/agent/galaxy/offers/EditOffer/EditOffer"));

const Testimonials = lazy(() => import("@/pages/agent/galaxy/testimonials/Testimonials/Testimonials"));
const AddTestimonial = lazy(() => import("@/pages/agent/galaxy/testimonials/AddTestimonial"));
const EditTestimonial = lazy(() => import("@/pages/agent/galaxy/testimonials/EditTestimonial/EditTestimonial"));

const Suppliers = lazy(() => import("@/pages/agent/galaxy/suppliers/Suppliers"));

const Analytics = lazy(() => import("@/pages/agent/galaxy/analytic/Analytics"));

const Settings = lazy(() => import("@/pages/agent/galaxy/settings/Settings"));

const ItcBookings = lazy(() => import("@/pages/agent/galaxy/itc-bookings/ItcBookings"));
const CruiseBookings = lazy(() => import("@/pages/agent/galaxy/cruise-bookings/CruiseBookings"));

const Error404 = lazy(() => import("@/pages/Error404"));

const galaxyRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "experiences",
    children: [
      {
        index: true,
        element: <Experiences />,
      },
      {
        path: "new",
        element: <AddExperience />,
      },
      {
        path: ":id",
        element: <EditExperience />,
      },
    ],
  },
  {
    path: "prospects",
    children: [
      {
        index: true,
        element: <Prospects />,
      },
      {
        path: "new",
        element: <AddProspect />,
      },
      {
        path: ":id",
        element: <EditProspect />,
      },
    ],
  },
  {
    path: "posts",
    children: [
      {
        index: true,
        element: <Posts />,
      },
      {
        path: "new",
        element: <AddPost />,
      },
      {
        path: ":id",
        element: <EditPost />,
      },
    ],
  },
  {
    path: "blogs",
    children: [
      {
        index: true,
        element: <Blogs />,
      },
      {
        path: "new",
        element: <AddBlog />,
      },
      {
        path: ":id",
        element: <EditBlog />,
      },
    ],
  },
  {
    path: "offers",
    children: [
      {
        index: true,
        element: <Offers />,
      },
      {
        path: "new",
        element: <AddOffer />,
      },
      {
        path: ":id",
        element: <EditOffer />,
      },
    ],
  },
  {
    path: "testimonials",
    children: [
      {
        index: true,
        element: <Testimonials />,
      },
      {
        path: "new",
        element: <AddTestimonial />,
      },
      {
        path: ":id",
        element: <EditTestimonial />,
      },
    ],
  },
  {
    path: "suppliers",
    children: [
      {
        index: true,
        element: <Suppliers />,
      },
    ],
  },
  {
    path: "itc-bookings",
    children: [
      {
        index: true,
        element: <ItcBookings />,
      },
    ],
  },
  {
    path: "cruise-bookings",
    children: [
      {
        index: true,
        element: <CruiseBookings />,
      },
    ],
  },
  {
    path: "analytics",
    children: [
      {
        index: true,
        element: <Analytics />,
      },
    ],
  },
  {
    path: "settings",
    children: [
      {
        index: true,
        element: <Settings />,
      },
    ],
  },
];

export default galaxyRoutes;
